export enum FileUploadType {
  ALL = 'ALL',
  IMAGES = 'IMAGES',
  PNG = 'PNG'
}
